import React from 'react';
import Divider from './Divider.jsx';

import '../utils/icons.css';
import './SideDropdown.css';

class SideDropdown extends React.Component {

    ref = React.createRef();

    state = {
        isOpen: false
    };

    componentDidMount() {
        document.addEventListener('mousedown', this.onClickOutside, false);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.onClickOutside, false);
    }

    onClickOutside = e => {

        if (this.ref.current && !this.ref.current.contains(e.target)) {
            this.setState({ isOpen: false });
        }

    };

    onToggleOpen = e => {

        this.setState({ isOpen: !this.state.isOpen });
    };

    onChangeOption = ({ currentTarget: { value: selected } }) => {

        this.props.onChange(selected);
        this.setState({ isOpen: false });
    };

    get options() {

        return this.props.options.filter(option => option !== this.props.selected).reduce((options, option, index) => {

            if (index > 0 && index % 2) {
                options.push(
                    <Divider key={index} />
                );
            }

            options.push(
                <button key={option} onClick={this.onChangeOption} value={option} disabled={!this.state.isOpen}>
                    {option}
                </button>
            );

            return options;

        }, []);
    }

    render() {

        return (
            <div ref={this.ref} className={`side-dropdown${this.state.isOpen ? ' open' : ''}`}>
                <div className="options">
                    {this.options}
                </div>
                <div className="selected">
                    <button onClick={this.onToggleOpen}>
                        <span className="icon-sort" />
                        <span className="icon-navigate_before" />
                        {this.props.selected}
                    </button>
                </div>
            </div>
        );
    }

    static get defaultProps() {

        const options = [ 'best', 'newest', 'oldest' ];

        return {
            options,
            selected: options[0],
            onChange: () => {}
        };
    }
}

export default SideDropdown;


// WEBPACK FOOTER //
// ./src/components/SideDropdown.jsx